import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import { action } from 'satcheljs';

// This action uses the word SharePoint while the rest of the package uses sharing because GetSharingInfo is
// SharePoint specific, so adding a SharePointLink will be a different process than adding an ODC/GDrive link.
// For the rest of the package it shouldn't matter where the link came from, so the more generic term 'sharing' is used.
// TODO VSO 33492: mutators should not take in the object they are mutating as a parameter.
export const addSharePointLink = action(
    'ADD_SHAREPOINT_LINK',
    (linkId: string, url: string, sharingLinkIds: string[], response: GetSharingInfoResponse) => ({
        linkId: linkId,
        url: url,
        sharingLinkIds: sharingLinkIds,
        response: response,
    })
);

// TODO VSO 33492: mutators should not take in the object they are mutating as a parameter.
export const removeSharingLink = action(
    'REMOVE_SHARING_LINK',
    (linkId: string, sharingLinkIds: string[]) => ({
        linkId: linkId,
        sharingLinkIds: sharingLinkIds,
    })
);
